import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Snackbar, Paper, Box, Typography, Button, IconButton } from '@mui/material';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import CloseIcon from '@mui/icons-material/Close';
import { supabase } from '../supabaseClient';
import { useAuth } from '../AuthContext';

// بوب أب لحظي لما توصلك رسالة شات جديدة، بغض النظر عن أنهي صفحة انت فيها -
// نفس نمط الاشتراك في IncomingCallAlert.js/DeductionAlert.js، لكن هنا
// بيسمع على جدول notifications نفسه (اللي sendMessage في ChatPage.js بيكتب
// فيه أصلاً لكل عضو تاني في المحادثة) بدل جدول مخصص، فمفيش داعي لأي منطق
// إضافي غير فلترة الروابط اللي بتبدأ بـ /chat.
const ChatMessageAlert = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [queue, setQueue] = useState([]);

  useEffect(() => {
    if (!currentUser?.id) return undefined;
    const channel = supabase
      .channel(`chat-alerts-${currentUser.id}`)
      .on(
        'postgres_changes',
        { event: 'INSERT', schema: 'public', table: 'notifications', filter: `user_id=eq.${currentUser.id}` },
        (payload) => {
          const row = payload.new;
          if (!row.link || !row.link.startsWith('/chat?c=')) return;
          setQueue((prev) => [...prev, row]);
        }
      )
      .subscribe();
    return () => {
      supabase.removeChannel(channel);
    };
  }, [currentUser?.id]);

  const current = queue[0] || null;

  const dismiss = () => setQueue((prev) => prev.slice(1));

  const openConversation = () => {
    if (!current) return;
    navigate(current.link);
    dismiss();
  };

  return (
    <Snackbar
      open={!!current}
      autoHideDuration={7000}
      onClose={(e, reason) => reason !== 'clickaway' && dismiss()}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Paper elevation={6} sx={{ p: 1.5, display: 'flex', alignItems: 'flex-start', gap: 1.5, maxWidth: 340, cursor: 'pointer' }} onClick={openConversation}>
        <ChatBubbleIcon color="primary" sx={{ mt: 0.5 }} />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }} noWrap>
            {current?.title}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
            {current?.body}
          </Typography>
          <Button size="small" sx={{ mt: 0.5, p: 0 }} onClick={openConversation}>
            افتح
          </Button>
        </Box>
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            dismiss();
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Paper>
    </Snackbar>
  );
};

export default ChatMessageAlert;
